/****************************************************************************
* Homepage hero & slides (fullPage.js)
* https://github.com/alvarotrigo/fullPage.js
****************************************************************************/

function fnHomeSlides( i, oSection ) {

	/**
	* Element
	*/
	var oSection					= $( oSection ),
		oHero						= $( '.hero', oSection ),
		oHeroVideo					= $( '.hero .hero-video', oSection ),
		oScrollDown					= $( 'aside.home-slides_fixed-scroll' ),
		oScrollDownLabel			= oScrollDown.find( '.label' ),
		oSlide						= $( '.slide', oSection );

	/***************
	* Hero title
	***************/
	// Wrap each word in title
	$( 'h1', oHero ).lettering( 'words' );

	/***************
	* Video
	***************/
	if ( oHeroVideo.length > 0 ) {

		// Initiate video on load
		var oHeroVideoPlayer		= new Vimeo.Player( oHeroVideo, {
			autoplay: 					true,
	        controls: 					false,
	        background: 				true,
	        responsive: 				false,
	        muted: 						true,
	        title: 						false,
	        loop: 						true
		} );

		// Run when video is ready to play/starts playing
		oHeroVideoPlayer.ready().then( function() {
		    oHero.addClass( 'video-is-playing' );
		} );

	}

	/***************
	* Initiate slides
	***************/
	$( '#fullpage' ).fullpage( {
		licenseKey: 				'52008CBA-44384663-B17F29FB-0753DF64',
		fixedElements: 				'aside.scroll-down',
		verticalCentered: 			false,
		onLeave: function( origin, destination ) {

			/**
			* Hero video
			*/

			if ( oHeroVideo.length > 0 ) {

				// If entering first item
				if ( destination.isFirst == true ) {

					oHeroVideoPlayer.play().then( function() {
					    oHero.addClass( 'video-is-playing' );
					} );

				// If leaving first item
				} else {

					oHeroVideoPlayer.pause().then( function() {
					    oHero.removeClass( 'video-is-playing' );
					} );

				}

			}

			/**
			* Scroll button
			*/

			// If entering last item
			if ( destination.isLast == true ) {

				oScrollDown.addClass( '-is-ended' );
				oScrollDownLabel.text( oScrollDownLabel.data( 'end-label' ) );

			// If leaving last item
			} else {

				oScrollDown.removeClass( '-is-ended' );
				oScrollDownLabel.text( oScrollDownLabel.data( 'label' ) );

			}

		}

	} );

	/***************
	* Scroll down button
	***************/
	$( '.button', oScrollDown ).on( 'click', function() {
		$.fn.fullpage.moveSectionDown();
	} );

	/***************
	* Parallax movement
	***************/
	$( oSlide ).each( function() {
	       
		var oPattern 				= $( this ).find( 'figure.pattern' ).get( 0 );
		var oParallaxPattern		= new Parallax( oPattern );
	       
    } );

}



// END OF DOCUMENT
